/* eslint-disable camelcase */
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import getLocalizedUrl from 'lib/utils/getLocalizedUrl';

const generateVMHrefLangs = (vehicleModelData, currentLocale, pageUrl) => {
  let canonicalLink = '';
  const { slug_translations: vModelSlugTranslations } = vehicleModelData.vehicle_model;
  const { slug_translations: vMakeSlugTranslations } = vehicleModelData.vehicle_model.vehicle_make;
  const { slug_translations: locationSlugTranslations } = vehicleModelData.location;

  const urlArrDefaults = pageUrl.split('/');

  const hrefLangs = Object.entries(mapNamedLocaleToLocale).map(
    ([namedLocale, standardLocale]) => {
      let url = '';
      [
        locationSlugTranslations,
        vMakeSlugTranslations,
        vModelSlugTranslations,
      ].forEach((slugTranslationType, index) => {
        if (!slugTranslationType) return;
        const slugTranslation = slugTranslationType.find((item) => item.locale === standardLocale)
          || slugTranslationType.find((item) => item.locale === 'en')
          || urlArrDefaults[index];

        url += slugTranslation.slug ? `/${slugTranslation.slug}` : '';
      });
      if (namedLocale === currentLocale) {
        canonicalLink = getLocalizedUrl(url, namedLocale);
      }
      return {
        url: getLocalizedUrl(url, namedLocale),
        hreflang: standardLocale === 'en' ? 'x-default' : standardLocale,
      };
    },
  );

  return {
    canonical: canonicalLink,
    urls: hrefLangs,
  };
};

export default generateVMHrefLangs;
